<script src="../router/index.js"></script>
<template>
  <b-container class="d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 80px); overflow: hidden;">
    <b-card shadow class="p-4" style="width: 100%; max-width: 400px; border-radius: 20px;">
      <h3 class="text-center font-weight-bold mb-4" style="color: #00A1E1;">사용자 로그인</h3>
      <b-form @submit.prevent="handleLogin">
        <b-form-group label="아이디" label-for="username">
          <b-form-input id="username" v-model="form.username" required placeholder="아이디를 입력하세요"></b-form-input>
        </b-form-group>

        <b-form-group label="비밀번호" label-for="password">
          <b-form-input id="password" v-model="form.password" type="password" required placeholder="비밀번호를 입력하세요"></b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary" block class="mt-4 py-2 font-weight-bold">로그인</b-button>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios';
import router from "@/router";

export default {
  data() {
    return {
      form: { username: '', password: '' }
    };
  },
  methods: {
    // LoginPage.vue 내 handleLogin 메서드
    async handleLogin() {
      try {
        const res = await axios.post('/api/auth/login', this.form);

        // res 자체가 서버에서 보낸 객체입니다.
        if (res.status === 200) {

          // 실제 유저 정보는 res.data 안에 있습니다.
          const userData = res.data;

          // 1. 비밀번호 초기화 여부 체크
          if (userData.userPasswordReset === "1") {
            localStorage.setItem('tempUsername', this.form.username);
            alert('보안을 위해 비밀번호를 새로 설정해야 합니다.');
            this.$router.push('/reset-password');
          } else {
            // 2. 정보 저장
            localStorage.setItem('token', userData.token);
            localStorage.setItem('refreshToken', userData.refreshToken);
            localStorage.setItem('userGroupType', userData.userGroupType);
            localStorage.setItem("userId", userData.userId);

            // Axios 공통 헤더 설정
            axios.defaults.headers.common['Authorization'] = `Bearer ${userData.token}`;

            this.$router.push('/');
          }
        } else {
          // 서버에서 status를 200이 아닌 값으로 보냈을 경우
          alert('로그인 실패: ' + (res.data.message || '알 수 없는 오류'));
        }
      } catch (error) {
        // ID/PW가 틀려 서버가 500이나 401 에러를 던진 경우 이쪽으로 옵니다.
        console.error('로그인 에러:', error);
        const msg = error.response?.data?.message || '아이디 또는 비밀번호를 확인하세요.';
        alert('로그인 실패: ' + msg);
      }
    }
  }
};
</script>
